export default __webpack_public_path__ + "static/media/b2.22e74f82.jpg";